<div class="loading" *ngIf="loading.isVisible()">
  <div class="loading-icon">
    <div class="container">
      <div class="cube"><div class="cube__inner"></div></div>
      <div class="cube"><div class="cube__inner"></div></div>
      <div class="cube"><div class="cube__inner"></div></div>
    </div>
  </div>
  <div class="loading-text">
    <p class="text-white font-semibold"> {{loading.description() }} </p>
  </div>
</div>